import { useEffect } from 'react';

import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';
import { ReportSummaryResponse } from '@/modules/Reports/report.types';

import { useBaseReportSummaryQuery } from '../../queries';
import { HealthPlanEnrollmentsReportParams } from '../HealthPlanEnrollmentReport.types';

export const QUERY_KEY = 'GET_REPORT_FORFEITURE_SUMMARY';
interface ClaimResponse extends ReportSummaryResponse {
  date_from: string;
  date_to: string;
}
const useHealthPlanEnrollmentsReportSummaryQuery = (params: HealthPlanEnrollmentsReportParams) => {
  const {
    data,
    isLoading,
    isLoadingMore,
    isSuccess,
    isEmptyData,
    lastTimeUpdateDate,
    planOptions,
    isHasNextPage,
    handleLoadMore,
    resetPagination,
  } = useBaseReportSummaryQuery<ClaimResponse>(
    API_URL.REPORTS_HEALTH_PLAN_ENROLLMENT_REPORT_SUMMARY,
    [QUERY_KEY, params.employerId, params?.planYearPeriod.join(',')],
    {
      employer_id: params.employerId,
      plan_year_period:
        params?.planYearPeriod && !params?.planYearPeriod.includes(ALL_OPTION_KEY)
          ? params?.planYearPeriod.join(',')
          : undefined,
    },
    {
      isWithTotal: params?.isWithTotal,
      disabled: !params.employerId,
      employerId: params.employerId,
      employerIds: params.employerIds,
    }
  );

  useEffect(() => {
    resetPagination();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.employerId, params?.planYearPeriod.join(',')]);

  return {
    lastTimeUpdateDate,
    planOptions,
    data,
    isLoading,
    isLoadingMore,
    isSuccess,
    isEmptyData,
    isHasNextPage,
    handleLoadMore,
  };
};

export default useHealthPlanEnrollmentsReportSummaryQuery;
